// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#button-link[data-v-c7450dbe]{font-size:var(--barbri-base-font-size,1rem);font-family:var(--babri-font-primary,\"Proxima Nova\"),sans-serif;line-height:48px;border:1px solid #1c75d4}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
